export default "__VITE_ASSET__Bi08rNNm__"